<template>
  <div>
    <MobileOverlay />
    <PersonalOffer :localeService="localeService" />
    <ObjectsTable
      :renderParams="renderParams"
      :version="version"
      :localeService="localeService"
    />
    <PersonalAgent
      :localeService="localeService"
      :renderParams="renderParams"
      :version="version"
    />
  </div>
</template>

<script>
import 'bootstrap/dist/css/bootstrap.css'
import PersonalOffer from '../common/PersonalOffer.vue'
import ObjectsTable from './ObjectsTable/ObjectsTable.vue'
import PersonalAgent from '../common/PersonalAgent.vue'
import Locale from '../../../services/locale'
import MobileOverlay from './MobileOverlay.vue'

export default {
  name: 'TableView',
  props: {
    renderParams: Object,
    version: String,
    localeService: Locale,
  },
  components: {
    PersonalOffer,
    ObjectsTable,
    PersonalAgent,
    MobileOverlay,
  },
}
</script>

<style scoped>
:deep(.container) {
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
}
</style>

<style>
body.presentation-table-view {
  font-size: 1em;
  line-height: 1.3;
}
body.presentation-table-view a:hover {
  cursor: pointer;
  text-decoration: none;
}
</style>
